export const emojiNameStr = [
  "[666]",
  "[Emm]",
  "[OK]",
  "[亲亲]",
  "[便便]",
  "[偷笑]",
  "[傲慢]",
  "[再见]",
  "[凋谢]",
  "[加油]",
  "[勾引]",
  "[发怒]",
  "[发抖]",
  "[可怜]",
  "[右哼哼]",
  "[叹气]",
  "[吃瓜]",
  "[合十]",
  "[吐]",
  "[呲牙]",
  "[咒骂]",
  "[咖啡]",
  "[哇]",
  "[啤酒]",
  "[嘘]",
  "[嘴唇]",
  "[嘿哈]",
  "[囧]",
  "[困]",
  "[坏笑]",
  "[天啊]",
  "[太阳]",
  "[失望]",
  "[奸笑]",
  "[好的]",
  "[委屈]",
  "[害羞]",
  "[尴尬]",
  "[庆祝]",
  "[弱]",
  "[强]",
  "[得意]",
  "[微笑]",
  "[心碎]",
  "[快哭了]",
  "[恐惧]",
  "[悠闲]",
  "[惊恐]",
  "[惊讶]",
  "[愉快]",
  "[憨笑]",
  "[打脸]",
  "[抓狂]",
  "[抠鼻]",
  "[抱拳]",
  "[拥抱]",
  "[拳头]",
  "[捂脸]",
  "[握手]",
  "[撇嘴]",
  "[擦汗]",
  "[敲打]",
  "[无语]",
  "[旺柴]",
  "[晕]",
  "[月亮]",
  "[机智]",
  "[汗]",
  "[流泪]",
  "[炸弹]",
  "[烟花]",
  "[爆竹]",
  "[爱心]",
  "[猪头]",
  "[玫瑰]",
  "[生病]",
  "[疑问]",
  "[發]",
  "[白眼]",
  "[皱眉]",
  "[睡]",
  "[破涕为笑]",
  "[礼物]",
  "[社会社会]",
  "[福]",
  "[红包]",
  "[翻白眼]",
  "[耶]",
  "[胜利]",
  "[脸红]",
  "[色]",
  "[苦涩]",
  "[菜刀]",
  "[蛋糕]",
  "[衰]",
  "[裂开]",
  "[让我看看]",
  "[调皮]",
  "[跳跳]",
  "[转圈]",
  "[鄙视]",
  "[闭嘴]",
  "[阴险]",
  "[难过]",
  "[骷髅]",
  "[鼓掌]",
  "[大哭]"
]

const weChatEmojis = emojiNameStr.map(item => {
  return {
    name: item,
    path: `https://tf-scrm-test.oss-cn-shenzhen.aliyuncs.com/weChatEmoji/${item}.png`
  }
})

export default weChatEmojis
